<template>
	<v-menu offset-y :close-on-content-click="false" :nudge-width="150" v-model="tag_dialog">
		<template v-slot:activator="{ on }">
	  	<v-btn small color="success" dark v-on="on">Edit</v-btn>
		</template>

  	<v-card style="min-width: 350px; max-width: 350px; padding: 10px;" v-if="tag_dialog">
  		<tag-editor :event_uuid="event_uuid" :uuid="uuid" v-on:save="tag_dialog=false"></tag-editor>
  	</v-card>
  </v-menu>
</template>

<script>

import TagEditor from '@/components/events/tags/Editor.vue'

export default {
	props: ["event_uuid", "uuid"],
	components: {
		TagEditor
	},
	data () {
		return {
				tag_dialog: false
			}
	},
}
</script>
